import React, { Fragment } from 'react'
import styled from 'styled-components'

import ApiSectionWrapper from '../shared/api-section-wrapper'
import DividerLine from '../shared/divider-line'
import SectionHeader from '../../mdx/api/schema/section-header.mdx'
import GifObject from '../../mdx/api/schema/gif-object.mdx'
import ImageObject from '../../mdx/api/schema/image-object.mdx'
import MetaObject from '../../mdx/api/schema/meta-object.mdx'
import PaginationObject from '../../mdx/api/schema/pagination-object.mdx'
import UserObject from '../../mdx/api/schema/user-object.mdx'
import RandomIdObject from '../../mdx/api/schema/randomId-object.mdx'
import AnalyticsObject from '../../mdx/api/schema/analytics-object.mdx'
import CategoryObject from '../../mdx/api/schema/category-object.mdx'
import SubCategoryObject from '../../mdx/api/schema/sub-category-object.mdx'
import TermObject from '../../mdx/api/schema/term-object.mdx'
import ChannelObject from '../../mdx/api/schema/channel-object.mdx'
import ChannelTagObject from '../../mdx/api/schema/channel-tag-object.mdx'

import DocsPageGlobalStyles from '../../styles/docs-page'

import Anchor from '../anchor'

const ObjectWrapper = styled(ApiSectionWrapper)`
    > table td:first-child {
        font-weight: normal;
    }
`

const ImageObjectWrapper = styled.div`
    table {
        empty-cells: hide;
    }

    table td {
        vertical-align: top;
    }
`

const SchemaObject = ({ children, anchorId, dividerLine = true }) => {
    return (
        <ObjectWrapper>
            {dividerLine ? <DividerLine /> : ''}
            <Anchor pathname="/docs/api/schema" id={anchorId} />
            {children}
        </ObjectWrapper>
    )
}

const EndpointsPage = () => {
    return (
        <Fragment>
            <div>
                <DocsPageGlobalStyles />
                <SectionHeader />
                <SchemaObject anchorId="gif-object" dividerLine={false}>
                    <GifObject />
                </SchemaObject>
                <SchemaObject anchorId="image-object">
                    <ImageObjectWrapper>
                        <ImageObject />
                    </ImageObjectWrapper>
                </SchemaObject>
                <SchemaObject anchorId="meta-object">
                    <MetaObject />
                </SchemaObject>
                <SchemaObject anchorId="pagination-object">
                    <PaginationObject />
                </SchemaObject>
                <SchemaObject anchorId="user-object">
                    <UserObject />
                </SchemaObject>
                <SchemaObject anchorId="random-id-object">
                    <RandomIdObject />
                </SchemaObject>
                <SchemaObject anchorId="analytics-object">
                    <AnalyticsObject />
                </SchemaObject>
                <SchemaObject anchorId="category-object">
                    <CategoryObject />
                </SchemaObject>
                <SchemaObject anchorId="sub-category-object">
                    <SubCategoryObject />
                </SchemaObject>
                <SchemaObject anchorId="term-object">
                    <TermObject />
                </SchemaObject>
                <SchemaObject anchorId="channel-object">
                    <ChannelObject />
                </SchemaObject>
                <SchemaObject anchorId="channel-tag-object">
                    <ChannelTagObject />
                </SchemaObject>
            </div>
        </Fragment>
    )
}

export default EndpointsPage
